import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a528b342")

_pushScopeId("data-v-a528b342")
const _hoisted_1 = {
  key: 0,
  class: "overflow-x-hidden"
}
const _hoisted_2 = {
  key: 0,
  class: "w-full text-xs text-gray-400 whitespace-nowrap truncate"
}
const _hoisted_3 = { class: "flex flex-row gap-1 items-center" }
const _hoisted_4 = {
  key: 1,
  class: "w-full text-xs text-gray-400 whitespace-nowrap truncate"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "flex flex-row items-center gap-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MButton = _resolveComponent("MButton")
  const _component_m_icon = _resolveComponent("m-icon")

  return (_openBlock(), _createBlock("div", {
    ref: "tableCellContainer",
    class: ["relative px-3 py-3 lg:flex flex-col text-sm text-left truncate", _ctx.dynamicClass]
  }, [
    (_ctx.isButton)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_MButton, {
            color: _ctx.button?.color,
            disabled: _ctx.button?.disable ?? false,
            onClick: _ctx.click
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.button?.text ? _ctx.button.text : _ctx.text), 1)
            ]),
            _: 1
          }, 8, ["color", "disabled", "onClick"])
        ]))
      : (_openBlock(), _createBlock("div", {
          key: 1,
          class: "overflow-x-hidden",
          onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleMouseEnterEvent($event)))
        }, [
          (_ctx.prefix)
            ? (_openBlock(), _createBlock("p", _hoisted_2, _toDisplayString(_ctx.prefix), 1))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_3, [
            (_ctx.copyable)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "cursor-pointer mt-1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyText($event)))
                }, [
                  _createVNode(_component_m_icon, { type: "clipboard-copy" })
                ]))
              : _createCommentVNode("", true),
            _createVNode("p", {
              ref: "textContainer",
              class: "text-container w-full whitespace-nowrap truncate"
            }, _toDisplayString(_ctx.property == "schoolAILinkageStatus" ? " " : _ctx.text), 513)
          ]),
          (_ctx.suffix)
            ? (_openBlock(), _createBlock("p", _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.property == 'schoolAILinkageStatus')
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("button", {
                  class: "text-xs text-blue py-1/2 px-2 rounded border border-black hover:px-4 hover:font-bold hover:bg-white",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openSchoolAI()), ["prevent"]))
                }, " ログを確認する ")
              ]))
            : _createCommentVNode("", true)
        ], 32)),
    _withDirectives(_createVNode("div", {
      class: "bubble absolute bg-white p-2 break-all z-10 shadow-lg rounded",
      onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleMouseLeaveEvent($event))),
      onClick: _cache[7] || (_cache[7] = 
        $event => {
          $event.preventDefault();
          $event.stopPropagation();
        }
      )
    }, [
      _createVNode("div", _hoisted_6, [
        (_ctx.copyable)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "mt-1",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copyText($event))),
              onMouseenter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addCursorClass($event)))
            }, [
              _createVNode(_component_m_icon, { type: "clipboard-copy" })
            ], 32))
          : _createCommentVNode("", true),
        _createVNode("span", null, _toDisplayString(_ctx.text), 1)
      ])
    ], 544), [
      [_vShow, _ctx.hover && _ctx.isHovered && _ctx.isOverFlowing]
    ])
  ], 2))
})